import React from 'react';
import styles from './ResetPassword.module.scss';
import ROUTES from 'routes.json';
import { RouterLink } from '../../components';
import { CardLayout } from '../CardLayout/CardLayout';

export const ResetPasswordLayout = ({ children }) => {
  return (
    <div data-test-page-name="ResetPassword">
      <CardLayout>
        {children}
        <span>
          Return to{' '}
          <RouterLink className={styles.link} to={ROUTES.LOGIN}>
            Login
          </RouterLink>
          .
        </span>
      </CardLayout>
    </div>
  );
};
